// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchBar-cls1__e743063083f9fd41ee1d{/*!*/}.SearchBar-cls2___3d9c16c971c37a9fc89{width:100%;position:relative;margin-right:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SearchBar-cls1__e743063083f9fd41ee1d",
	"cls2": "SearchBar-cls2___3d9c16c971c37a9fc89 SearchBar-cls1__e743063083f9fd41ee1d"
};
export default ___CSS_LOADER_EXPORT___;
